import "preact/debug";
import PaginationBoxView from "react-paginate/react_components/PaginationBoxView";
import { classNameIfDefined } from 'react-paginate/react_components/utils';

/**
 * Workaround for accessability issue with react paginate until patched
 * See: https://github.com/AdeleD/react-paginate/pull/494#issuecomment-2317450265
 * @param {function} handlePageClick
 * @param {number} pageCount
 * @returns
 */
export class ReactPaginateExtended extends PaginationBoxView{
  constructor(props) {
    super(props);
  }

  render() {
      const { renderOnZeroPageCount } = this.props;
      if (this.props.pageCount === 0 && renderOnZeroPageCount !== undefined) {
        return renderOnZeroPageCount
          ? renderOnZeroPageCount(this.props)
          : renderOnZeroPageCount;
      }
      const {
        disabledClassName,
        disabledLinkClassName,
        pageCount,
        className,
        containerClassName,
        previousLabel,
        previousClassName,
        previousLinkClassName,
        previousAriaLabel,
        prevRel,
        nextLabel,
        nextClassName,
        nextLinkClassName,
        nextAriaLabel,
        nextRel,
      } = this.props;
  
      const { selected } = this.state;
  
      const isPreviousDisabled = selected === 0;
      const isNextDisabled = selected === pageCount - 1;
  
      const previousClasses = `${classNameIfDefined(previousClassName)}${
        isPreviousDisabled ? ` ${classNameIfDefined(disabledClassName)}` : ''
      }`;
      const nextClasses = `${classNameIfDefined(nextClassName)}${
        isNextDisabled ? ` ${classNameIfDefined(disabledClassName)}` : ''
      }`;
  
      const previousLinkClasses = `${classNameIfDefined(previousLinkClassName)}${
        isPreviousDisabled ? ` ${classNameIfDefined(disabledLinkClassName)}` : ''
      }`;
      const nextLinkClasses = `${classNameIfDefined(nextLinkClassName)}${
        isNextDisabled ? ` ${classNameIfDefined(disabledLinkClassName)}` : ''
      }`;
  
      const previousAriaDisabled = isPreviousDisabled ? 'true' : 'false';
      const nextAriaDisabled = isNextDisabled ? 'true' : 'false';
  
      return (
        <ul
          className={className || containerClassName}
          aria-label="Pagination"
        >
          <li className={previousClasses}>
            <a
              className={previousLinkClasses}
              href={this.getElementHref(selected - 1)}
              tabIndex={isPreviousDisabled ? '-1' : '0'}
              role="button"
              onKeyPress={this.handlePreviousPage}
              aria-disabled={previousAriaDisabled}
              aria-label={previousAriaLabel}
              rel={prevRel}
              {...this.getEventListener(this.handlePreviousPage)}
            >
              {previousLabel}
            </a>
          </li>
  
          {this.pagination()}
  
          <li className={nextClasses}>
            <a
              className={nextLinkClasses}
              href={this.getElementHref(selected + 1)}
              tabIndex={isNextDisabled ? '-1' : '0'}
              role="button"
              onKeyPress={this.handleNextPage}
              aria-disabled={nextAriaDisabled}
              aria-label={nextAriaLabel}
              rel={nextRel}
              {...this.getEventListener(this.handleNextPage)}
            >
              {nextLabel}
            </a>
          </li>
        </ul>
      );
    }
}